var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiSummaryStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4482 12.7002L10.5762 13.0195L10.9014 13.1309L14.0859 14.2217L10.9014 15.3135L10.5762 15.4248L10.4482 15.7441L9.2002 18.8672L7.95215 15.7441L7.82422 15.4248L7.49805 15.3135L4.31348 14.2217L7.49805 13.1309L7.82422 13.0195L7.95215 12.7002L9.2002 9.57617L10.4482 12.7002Z",
    stroke: "#616161",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3486 7.19824L17.4766 7.51758L17.8027 7.62891L18.8848 8L17.8027 8.37109L17.4766 8.48242L17.3486 8.80176L16.8779 9.97852L16.4082 8.80176L16.2803 8.48242L15.9551 8.37109L14.8721 8L15.9551 7.62891L16.2803 7.51758L16.4082 7.19824L16.8779 6.02051L17.3486 7.19824Z",
    stroke: "#616161",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSummaryStar);
export default __webpack_public_path__ + "static/media/ai_summary_star.59c75c8e5219d87fb242cbdf3c1f14a5.svg";
export { ForwardRef as ReactComponent };